import { render, staticRenderFns } from "./FigureImage.vue?vue&type=template&id=3d57a859&"
import script from "./FigureImage.vue?vue&type=script&lang=js&"
export * from "./FigureImage.vue?vue&type=script&lang=js&"
import style0 from "./FigureImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports